import * as React from "react";
import SlideUpPopup from "../../../generic/slideUpPopup";
import PositionDetailMob from "../positionDetail/positionDetailMob";
import ObCheckbox from "../../orderBook/generic/obCheckbox";

export interface IPositionTblRowMobProps {
	data: any;
	isAccordianOpen: boolean;
	isSelectEnable: boolean;
	toggleTab: (e: any) => void;
	onSelect: () => void;
}

const PositionTblRowMob: React.FC<IPositionTblRowMobProps> = props => {
	return (
		<li className="pos_data_row" onClick={props.toggleTab}>
			<div className="lft_cont">
				{props.isSelectEnable && (
					<div className="col chkbx">
						<ObCheckbox
							name="eqTradeSelect"
							checked={props.data.isSelected}
							onChange={() => {
								props.onSelect();
							}}
						/>
					</div>
				)}
				<div className="left_content">
					<p className="symb_nm pd-b5" dangerouslySetInnerHTML={{ __html: props.data.name }} />
					<p>
						<span className="qty pd-r10">{props.data.ntQty} Qty</span>
						<span className="price pd-r10">
							<i className="at_icon">@</i> <span className="rupy">₹</span>
							{props.data.trsTyp === "B" ? props.data.avgByPrc : props.data.avgSlPrc}
						</span>
						<span className="prod_typ">{props.data.prdCode}</span>
					</p>
				</div>
			</div>
			<div className="rgt_cont">
				{/* according to value need to change clas "pos" or "neg" */}
				<p className={"ttl_mtm pd-b5 " + (props.data.mtm > 0 ? "pos" : props.data.mtm < 0 ? "neg" : "")}>
					<span className="rupy">₹</span>
					{props.data.mtm}
				</p>
				<p className="ltp">
					<span className="ltp_txt">LTP </span> {props.data.ltp}
				</p>
			</div>
			{props.isAccordianOpen && (
				<SlideUpPopup closePopup={() => props.toggleTab("close")}>
					<PositionDetailMob onClose={() => props.toggleTab("close")} data={props.data} />
				</SlideUpPopup>
			)}
		</li>
	);
};

export default PositionTblRowMob;
